import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { EntityContext } from "../../../contexts/EntityContext";
import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";
import SvgIcons from "../svgIcons";
import { CloseButton } from "../closeButton";
const TableTitleBar = styled(Box)(
  ({ theme }) => `
        width: 100%;
        height: 100%;
        padding:${theme.spacing(0.25)} 0;
        // margin-bottom: ${theme.spacing(2.5)};
       
`
);
const TitleContainer = styled(Box)(
  ({ theme }) => `
        width: 100%;
        display:flex;
        align-items: center;
        justify-content: start;
        & .titleBarTitle{
        font-weight: ${theme.text.fontWeights.medium} ;
        font-size: ${theme.text.fontSizes["2xl"]} ;
        color:${theme.colors.primary.main};
        margin-right:32px;
        }
`
);
const CounterBox = styled(Box)(
  ({ theme }) => `
        width: auto;
        display:flex;
        border-radius: 3px;
background: #D3E3E0;
color:${theme.colors.primary.main};
font-feature-settings: 'liga' off, 'clig' off;
font-size: 10px;
font-style: normal;
font-weight: ${theme.text.fontWeights.regular};
line-height: 20px; /* 200% */
 color:${theme.colors.primary.main};
        align-items: center;
        padding:4px 12px;
        
`
);
const TitleDescription = styled(Box)(
  ({ theme }) => `
  color: #9C9C9C;
font-feature-settings: 'liga' off, 'clig' off;
font-size: ${theme.text.fontSizes.xs};
font-style: normal;
font-weight: ${theme.text.fontWeights.light} ;
line-height: 20px; /* 166.667% */
padding-bottom: 15px;
        
`
);

export type TitleBarProps = {
  title: string;
  headerTitle?: string;
  subHeading?: string;
  rowCount?: number;
  buttonTitle?: any;
  onClick?: Function;
  disabled?: boolean;
  children?: React.ReactNode;
  buttonLoading?: boolean;
  dirty?: boolean;
  titleBarNodes?: React.ReactNode;
  filter?: boolean;
  editColumns?: boolean;
  editCloseIcon?: {
    visible: boolean;
    onClick?: Function;
  };
};
const TitleBar: FC<TitleBarProps> = ({
  title,
  headerTitle = null,
  subHeading,
  rowCount,
  buttonTitle,
  onClick,
  disabled,
  children,
  buttonLoading = false,
  titleBarNodes,
  filter,
  editColumns,
  editCloseIcon,
}) => {
  const { setEntityName } = useContext(EntityContext);

  useEffect(() => {
    if (title) setEntityName({ entityName: title, entityTitle: headerTitle });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <TableTitleBar>
      <Grid
        container
        justifyContent="space-between"
        alignItems="baseline"
        className="titleBar"
        sx={{ px: 3 }}
      >
        <Grid item xs={6} alignItems={"left"} className="title">
          <TitleContainer>
            <Typography className="titleBarTitle">{title}</Typography>
            {(rowCount ?? 0) > 0 && <CounterBox>{rowCount} Total</CounterBox>}
          </TitleContainer>
          {subHeading && <TitleDescription>{subHeading}</TitleDescription>}
        </Grid>

        <Grid item alignItems={"right"} display={"flex"} gap={1} sx={{ mb: 3 }}>
          {filter && (
            <Button variant="outlined" startIcon={<SvgIcons.TableFilterIcon />}>
              Filter
            </Button>
          )}
          {editColumns && (
            <Button
              variant="outlined"
              startIcon={<SvgIcons.TableEditColumnIcon />}
            >
              Edit Column
            </Button>
          )}
          {buttonTitle && onClick ? (
            <LoadingButton
              loading={buttonLoading}
              variant="contained"
              size="small"
              id={`${title}-${buttonTitle}`}
              disabled={disabled ?? false}
              onClick={() => onClick && onClick()}
              startIcon={<SvgIcons.AddButtonIcon />} // Add icon here
            >
              {buttonTitle}
            </LoadingButton>
          ) : null}
          {editCloseIcon?.visible && (
            <CloseButton
              onClick={() => editCloseIcon?.onClick && editCloseIcon?.onClick()}
            />
          )}
        </Grid>
      </Grid>
      <Divider />
      {(titleBarNodes || children) && (
        <Grid
          item
          container
          sx={{ px: 1 }}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Grid item xs={3.5} sx={{ my: 2 }}>
            {titleBarNodes}
            {children}
          </Grid>
          {/* <Grid item xs={2} sx={{ m: 1 }}>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Active Users</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              label="Active Users"

            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small-label">User Types</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              label="User Types"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </FormControl>
        </Grid> */}
          {/* <Grid item xs={2} display="flex" justifyContent="end">
          <Button
            variant="outlined"
            endIcon={<SvgIcons.TableCloseIcon />}
            sx={{
              "& .MuiButton-endIcon": {
                paddingRight: 2, // Add spacing here
                width: "30px", // Adjust width as needed
              },
            }}
          >
            Clear All
          </Button>
        </Grid> */}
        </Grid>
      )}
    </TableTitleBar>
  );
};

export default TitleBar;
